export default {
	SET_MEDICINE(state, payload) {
		state.list = payload;
	}, SET_MEDICINE_HISTORY(state, payload) {
		state.history.list = payload;
	}, SET_MEDICINE_PENDING(state, payload) {
		state.pending.list = payload;
	}, FILTER_STUDENT_MEDICINE(state, payload) {
		state.filter.student = payload;
	}, FILTER_DATE_MEDICINE(state, payload) {
		state.filter.date = payload;
	}, SET_REJECT_MEDICINE(state, payload) {
		state.pending.list[payload].reject = !state.pending.list[payload].reject;
	}
};



// WEBPACK FOOTER //
// ./sources/app/medicine/mutations.js